import React, { useState } from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, CheckCircle2Icon } from 'lucide-react';
import { ContactSection } from '../ContactSection';
const INFO_ITEMS = [{
  icon: <MapPinIcon className="h-5 w-5" aria-hidden="true" data-id="element-180" />,
  label: '拠点',
  value: '神奈川県横須賀市（地域密着で対応）'
}, {
  icon: <PhoneIcon className="h-5 w-5" aria-hidden="true" data-id="element-181" />,
  label: 'お電話',
  value: '046-000-0000（平日 9:00〜18:00）'
}, {
  icon: <MailIcon className="h-5 w-5" aria-hidden="true" data-id="element-182" />,
  label: 'メール',
  value: 'hello@optidsa.example'
}];
export function ContactBand() {
  const [submitted, setSubmitted] = useState(false);
  const handleSubmit = (data: {
    name: string;
    email: string;
    message: string;
  }) => {
    // デモ用: 実送信は行わず、完了状態を表示
    // eslint-disable-next-line no-console
    console.log('無料デモ予約リクエスト:', data);
    setSubmitted(true);
  };
  return <ContactSection id="contact" className="scroll-mt-24" eyebrow="無料デモを試す" title={submitted ? <span className="inline-flex items-center gap-2" data-id="element-184">
            <CheckCircle2Icon className="h-7 w-7 text-sage-green" aria-hidden="true" data-id="element-185" />
            ご予約ありがとうございます
          </span> : 'まずは無料デモから、始めてみませんか？'} description={submitted ? '担当者より折り返しご連絡いたします。AI受付スタッフを実際に体験して、現場がどれだけ軽くなるかをご確認ください。' : '契約はまだ先で大丈夫です。AI受付スタッフが電話・予約・問い合わせをどう引き受けるか、リスクなくその目でお確かめください。ITに詳しくなくても、私たちが最後まで伴走します。'} infoItems={INFO_ITEMS} submitLabel="無料デモを体験する" onSubmit={handleSubmit} data-id="element-183" />;
}